import { FC } from 'react';
import { getCssVarValue } from '@mybonum/ui';
import { Flex } from 'antd';

import { TCustomerType } from '../../types.ts';

import { ColumnsConfigurator } from '@/widgets/columns-configurator';
import { Search } from '@/widgets/search';

export const CustomersFilter: FC = () => {
    return (
        <Flex gap={getCssVarValue('spacing-sm', true)} wrap="wrap">
            <Search style={{ maxWidth: '450px' }} />
            <ColumnsConfigurator<TCustomerType> />
        </Flex>
    );
};
